import styles from './UIGamePlayerInformationCards.module.scss';
import { PlayerColor } from '@colonist/game-states';
import { T, Tooltip } from '@colonist/ui';
import { UIGameCount } from '../../../common/UIGameCount/UIGameCount.tsx';
import clsx from 'clsx';
import React from 'react';
import { UIGameProgressCardTooltipBody } from '../../../common/UIGameProgressCardTooltipBody/UIGameProgressCardTooltipBody.tsx';
import CardResCardBack from '@static/images/card_rescardback.svg';
import CardProgressBack from '@static/images/card_progress_back.svg';
import CardDevCardBack from '@static/images/card_devcardback.svg';
import CardResCardOverLimit from '@static/images/card_rescardoverlimit.svg';
const CustomCard = ({ count, tooltipBody, tooltipTitle, cardImage, centerText })=>/*#__PURE__*/ React.createElement(Tooltip, {
        centerText: centerText,
        className: styles.cardContainer,
        content: tooltipBody,
        title: tooltipTitle
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.cardImage,
        src: cardImage
    }), count != null && /*#__PURE__*/ React.createElement(UIGameCount, {
        className: styles.countBadge,
        color: PlayerColor.Blue,
        count: count
    }));
export const UIGamePlayerInformationCards = ({ isCityAndKnightMode, isCurrentUser, amountOfDevelopmentCards, translationContext, amountOfResourceCards, cardDiscardLimit, progressCards, modeSetting })=>{
    const isResourceCardOverLimit = amountOfResourceCards > cardDiscardLimit;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, {
            [styles.currentUser]: isCurrentUser
        })
    }, /*#__PURE__*/ React.createElement("div", {
        "data-resource-card": true
    }, /*#__PURE__*/ React.createElement(CustomCard, {
        cardImage: isResourceCardOverLimit ? CardResCardOverLimit : CardResCardBack,
        count: amountOfResourceCards,
        tooltipBody: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.playerInformation.resourceCard.body',
                options: {
                    context: translationContext
                }
            }
        })), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.playerInformation.resourceCard.discardLimitTip',
                options: {
                    count: cardDiscardLimit
                }
            }
        }))),
        tooltipTitle: /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.playerInformation.resourceCard.title',
                options: {
                    context: translationContext
                }
            }
        })
    })), /*#__PURE__*/ React.createElement("div", {
        "data-development-card": true
    }, isCityAndKnightMode ? /*#__PURE__*/ React.createElement(CustomCard, {
        cardImage: CardProgressBack,
        centerText: true,
        count: amountOfDevelopmentCards,
        tooltipBody: /*#__PURE__*/ React.createElement(UIGameProgressCardTooltipBody, {
            progressCards: progressCards,
            modeSetting: modeSetting
        }),
        tooltipTitle: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.progressCard"
        })
    }) : /*#__PURE__*/ React.createElement(CustomCard, {
        cardImage: CardDevCardBack,
        count: amountOfDevelopmentCards,
        tooltipBody: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.developmentCard.body"
        }),
        tooltipTitle: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.developmentCard.title"
        })
    })));
};
